import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { districtsListApi, talukasListApi, villagesListApi } from "Apis/member";

export const CommonContext = createContext();

export const CommonContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);

  // District Listening
  const districtList = async () => {
    let data = await districtsListApi();
    if (data?.status === 200) {
      const districtOptions = data?.data?.data?.rows?.map((district) => ({
        label: district.name,
        value: district.id,
      }));
      setDistricts(districtOptions);
    }
  };

  // Taluka Listening with filter
  const talukaList = async (value) => {
    let data = await talukasListApi(value);
    if (data?.status === 200) {
      const talukaOptions = data?.data?.data?.rows?.map((taluka) => ({
        label: taluka.name,
        value: taluka.id,
      }));
      setTalukas(talukaOptions);
    }
  };

  // Village Listening with filter
  const villageList = async (value) => {
    let data = await villagesListApi(value);
    if (data?.status === 200) {
      const villageOptions = data?.data?.data?.rows?.map((village) => ({
        label: village.name,
        value: village.id,
      }));
      setVillages(villageOptions);
    }
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <CommonContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        districtList,
        districts,
        setDistricts,
        talukaList,
        talukas,
        setTalukas,
        villageList,
        villages,
        setVillages,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
};

export default CommonContextProvider;
CommonContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
